import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { SearchType } from '@/types/most-search-type';

interface CtaProcedureAssistedPurchaseButtonProps extends React.HTMLAttributes<HTMLAnchorElement> {
  hasMedprevOnline: boolean;
  assistedShopUrl: string;
  city: string;
  state: string;
  procedureName?: string;
  originCta?: string;
  searchType: SearchType;
}

export function CtaProcedureAssistedPurchaseButton({
  hasMedprevOnline,
  assistedShopUrl,
  city,
  state,
  procedureName,
  originCta,
  searchType,
}: CtaProcedureAssistedPurchaseButtonProps) {
  const variant = hasMedprevOnline ? 'secondary' : 'default';
  const properties
    = searchType == SearchType.LABORATORIAL_EXAM
      ? { exame_nome: procedureName }
      : { especialidade_nome: procedureName };

  return (
    <Link
      prefetch={false}
      data-testid={DataTestIdEnum.SEO_CTA_ASSISTED_PURCHASE_BUTTON}
      href={assistedShopUrl}
      target="_blank"
      data-analytics-event={
        SearchType.LABORATORIAL_EXAM
          ? AnalyticsEnum.CLICK_CTA_SCHEDULE_EXAM_BY_ASSISTED_PURCHASE_BUTTON
          : AnalyticsEnum.CLICK_CTA_SCHEDULE_SPECIALTY_BY_SUPPORT
      }
      data-analytics-properties={JSON.stringify({
        secao_origem: originCta,
        cidade: city,
        estado: state,
        ...properties,
      })}
    >
      <Button variant={variant} startIcon={faWhatsapp} className="h-12">
        Agendar com atendente
      </Button>
    </Link>
  );
}
